import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Search } from 'lucide-react';
import { Pocket } from '@/ui/Pocket';
import { cn } from '@/utils/merge';
import { commApi } from './commApi';
import { ROLE_LABELS } from './format';

// Pick who to talk to, among the roles this user may start a conversation
// with (from /comm/me). The server checks everything again.
export const NewConversation = ({ me, cityId, onClose, onStarted }) => {
	const roles = me?.canStart || [];
	const [role, setRole] = useState(roles[0] || null);
	// { role, list } — null list while the chosen role's contacts load.
	const [loaded, setLoaded] = useState({ role: null, list: null });
	const contacts = loaded.role === role ? loaded.list : null;
	const [search, setSearch] = useState('');

	useEffect(() => {
		if (!role) return undefined;
		let alive = true;
		commApi.contacts(role, cityId).then(res => {
			if (alive) setLoaded({ role, list: res?.contacts || [] });
		});
		return () => {
			alive = false;
		};
	}, [role, cityId]);

	const start = async contact => {
		const res = await commApi.start({ toRole: contact.role, toUserId: contact.userId, cityId });
		if (res?.error) {
			toast.error(typeof res.error === 'string' ? res.error : 'Κάποιο πρόβλημα προέκυψε');
			return;
		}
		onStarted(res.conversationId);
	};

	const q = search.trim().toLowerCase();
	const shown = (contacts || []).filter(c => !q || c.name.toLowerCase().includes(q));

	return (
		<Pocket open title='Νέα συνομιλία' onOpenChange={onClose} onClose={onClose}>
			<div className='flex w-full flex-col gap-3 md:w-[420px]'>
				{!roles.length && (
					<div className='text-[14px] text-slate-500'>
						Δεν έχετε δικαίωμα να ξεκινήσετε συνομιλία.
					</div>
				)}
				<div className='flex flex-wrap gap-2'>
					{roles.map(r => (
						<button
							key={r}
							type='button'
							onClick={() => setRole(r)}
							className={cn(
								'rounded-md border px-3 py-1.5 text-[14px]',
								role === r
									? 'border-[#0f9b9d] bg-[#0f9b9d] text-white'
									: 'border-slate-300 bg-white',
							)}
						>
							{ROLE_LABELS[r]}
						</button>
					))}
				</div>
				{role && role !== 'admin' && (
					<div className='flex items-center gap-2 rounded-md border border-slate-300 px-2'>
						<Search size={16} className='text-slate-400' />
						<input
							className='h-9 flex-1 text-[14px] outline-none'
							placeholder='Αναζήτηση…'
							value={search}
							onChange={e => setSearch(e.target.value)}
						/>
					</div>
				)}
				<div className='flex max-h-[50vh] flex-col overflow-y-auto'>
					{contacts === null && role && <div className='p-3 text-slate-400'>Φόρτωση…</div>}
					{shown.map(c => (
						<button
							key={c.userId || 'team'}
							type='button'
							onClick={() => start(c)}
							className='border-b border-slate-100 px-2 py-2 text-left text-[14px] hover:bg-slate-50'
						>
							{c.name}
							<span className='ml-2 text-[12px] text-slate-400'>{ROLE_LABELS[c.role]}</span>
						</button>
					))}
					{contacts && !shown.length && (
						<div className='p-3 text-slate-400'>Κανένα αποτέλεσμα.</div>
					)}
				</div>
			</div>
		</Pocket>
	);
};
